import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
  import { Injectable } from '@angular/core';
  import { Observable, catchError, throwError } from 'rxjs';
  import { AnalyticsService } from '../../service/google-analytics.service';
  import { NGXLogger } from 'ngx-logger';

  @Injectable()
  export class ErrorTrackingInterceptor implements HttpInterceptor {
    constructor(private analytics: AnalyticsService, private logger: NGXLogger) {}

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

      // Only watch survey calls
      if (!req.url.includes('/Survey/')) {
        return next.handle(req);
      }

      return next.handle(req).pipe(
        catchError((err: HttpErrorResponse) => {

          const requestBody  = truncate(JSON.stringify(req.body),  200);
          const responseBody = truncate(JSON.stringify(err.error), 200);

          /* 🔎 smoke‑test */
          this.logger.log(
            '%c[Survey‑Interceptor] GA payload →',
            'color:orange;font-weight:bold',
            {
              url          : req.urlWithParams,
              method       : req.method,
              status_code  : err.status,
              request_body : requestBody,
              response_body: responseBody
            });

          /* send to GA */
          this.analytics.trackEvent('api_error', {
            event_category : 'API',
            event_label    : `${req.method} ${req.urlWithParams}`,
            status_code    : err.status,
            error_message  : responseBody,
            request_body   : requestBody,
            response_body  : responseBody
          });

          return throwError(() => err);
        })
      );

    }
  }

  function truncate(str: string, max = 200) {
    return str && str.length > max ? str.slice(0, max) + '…' : str;
  }

